import * as React from "react";
import { TopupService } from "../services/topup-service";
import { ReceiptTrx } from "../types";
import { Props } from "../../types/global";
import TrxSuccessful from "./TrxSuccessful";
import TrxPending from "./TrxPending";
import TrxFailed from "./TrxFailed";
import { messageDialog } from "../dialogs/MessageDialog";
import { ProductCategory } from "../types-enums";
import { removeGuestEmail } from "../services/helper-service";
declare type ReceiptState = {
    receiptTrx?: ReceiptTrx;
    isGuestCheckout: boolean;
}
export default class Receipt extends React.Component<Props, ReceiptState> {
    readonly state: ReceiptState = { isGuestCheckout: false };
    async componentDidMount() {
        const { transactionId, sessionId, guestTrxId } = this.props.location.query;
        const response = await TopupService.fetchReceipt(transactionId, sessionId, guestTrxId);
        if (!response) return;
        if (response.responseCode !== 0) {
            messageDialog(response.responseMessage || "", "Receipt");
        }
        if(response.payLoad && response.payLoad.receipt.isFfwdTrx){
            window.location.href = response.payLoad.receipt.ffwdRedirectUrl;
            return;
        }
        this.setState({ receiptTrx: response.payLoad, isGuestCheckout: guestTrxId ? true : false });
        await this.logoutGuest();
    }
    async componentWillReceiveProps(nextProps: Props) {
        if (nextProps.location.query.transactionId === this.props.location.query.transactionId) return;
        const { transactionId, sessionId, guestTrxId } = nextProps.location.query;
        const response = await TopupService.fetchReceipt(transactionId, sessionId, guestTrxId);
        if (!response) return;
        if (response.responseCode !== 0) {
            messageDialog(response.responseMessage || "", "Receipt");
        }
        this.setState({ receiptTrx: response.payLoad, isGuestCheckout: guestTrxId ? true : false });
    }
    onRepeat = (sessionId: string, category: ProductCategory) => {
        if(category === ProductCategory.GiftCard)
        {
            this.props.history.push(`/giftcard?sid=${sessionId}&step=summary`);
        }
        else
        {
            this.props.history.push(`/topup?sid=${sessionId}&step=summary`);
        }
    }
    render() {
        if (!this.state.receiptTrx) return null;
        const { receipt, pastTransactions: history } = this.state.receiptTrx;
        const trxStatus = TopupService.getTransactionStatus(receipt);
        if (trxStatus === "success") {
            return <TrxSuccessful receipt={receipt} history={history} onRepeat={this.onRepeat} isGuestCheckout={this.state.isGuestCheckout} />
        } else if (trxStatus === "pending") {
            return <TrxPending receipt={receipt} pastTrx={history} />;
        } else {
            return <TrxFailed receipt={receipt} pastTrx={history} />;
        }
    }
    async componentWillUnmount() {
        await this.logoutGuest();
    }

    async logoutGuest() {
        if (this.state.isGuestCheckout) {
            removeGuestEmail();
        }
    }
}
